import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=fb980cfe&scoped=true"
import script from "./userList.vue?vue&type=script&lang=js"
export * from "./userList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user/userList.css?vue&type=style&index=0&id=fb980cfe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb980cfe",
  null
  
)

export default component.exports